import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Livrare',
    pickup: 'Ridicare',
    room_service: 'La fața locului',
    table_service: 'La fața locului',
  },
  asap: 'Cât mai curând',
  unavailable: 'Indisponibil',
  ready_in_time: 'Gata în {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Livrare la {{address}}',
    [ORDER_METHODS.PICKUP]: 'Ridicare de la {{address}}',
    [ORDER_METHODS.ROOM_SERVICE]: 'La fața locului la {{address}}',
  },
  buttons: {
    change: 'Schimbă',
    see_hours: 'Vezi programul',
    change_location: 'Schimbă locația',
    change_time: 'Schimbă ora',
  },
};
